import { FC } from 'react';

const Algoverse: FC = () => {
  return (
    <footer className="upstocks-footer">
      <div className="container">
        <div className="padding d-flex flex-column text-sm">
          <p>
            Upstox Securities Pvt. Ltd.: SEBI Registration No. INZ000315837 | NSE TM Code: 13942 | BSE TM
            Code: 6155 | MCX TM Code: 46510 | CDSL Reg No.: IN-DP-761-2024 | CIN: U65100DL2021PTC376860 |
            Compliance Officer: Mr. Kapil Jaikalyani. Tel No.: (022) 24229920. Email ID:&nbsp;
            <a href="mailto:compliance@upstox.com" target="blank">
              compliance@upstox.com
            </a>
            &nbsp; | Registered Address: 809, New Delhi House, Barakhamba Road, Connaught Place, New Delhi -
            110001 | Correspondence Address: 30th Floor, Sunshine Tower, Senapati Bapat Marg, Dadar (West),
            Mumbai - 400013. | For any complaints, email at complaints@upstox.com and
            complaints.mcx@upstox.com.
          </p>

          <div>
            <p>
              <strong>About the Company</strong>
            </p>
            <p>
              Upstox Securities Private Limited is a wholly owned subsidiary of RKSV Securities India Private
              Limited and RKSV Commodities India Private Limited is an associate of RKSV Securities India
              Private Limited.
            </p>
          </div>

          <div>
            <p>
              <strong>SEBI Scores</strong>
            </p>
            <p>
              Procedure to file a complaint on&nbsp;
              <a href="https://scores.sebi.gov.in/" target="blank">
                SEBI SCORES
              </a>
              : Register on the SCORES portal. Mandatory details for filing complaints on SCORES include:
              Name, PAN, Address, Mobile Number, and E-mail ID. Benefits include effective communication and
              speedy redressal of grievances. Please ensure you carefully read the&nbsp;
              <a href="https://upstox.com/forms/" target="blank">
                Risk Disclosure Document
              </a>
              &nbsp; as prescribed by SEBI, along with our
              <a href="https://upstox.com/terms-of-use-and-privacy-policy/" target="blank">
                &nbsp;Terms of Use and Privacy Policy
              </a>
              .
            </p>
          </div>

          <div>
            <p>
              <strong>Attention to Investors</strong>
            </p>
            <p>
              <strong>Smart Online Dispute Resolution:</strong> SEBI has established an
              <a href="https://smartodr.in/login" target="blank">
                &nbsp;Online Dispute Resolution Portal (ODR Portal)&nbsp;
              </a>
              for resolving disputes in the Indian Securities Market. This
              <a
                href="https://www.sebi.gov.in/legal/circulars/jul-2023/online-resolution-of-disputes-in-the-indian-securities-market_74794.html"
                target="blank"
              >
                &nbsp;circular&nbsp;
              </a>
              streamlines the existing dispute resolution mechanism, offering online conciliation and
              arbitration, benefiting investors and listed companies.
            </p>
          </div>

          <p>
            <strong>Collateral:</strong> Clearing Corporation has provided a web based facility that allows
            clients to view their disaggregated collateral placed. Please access them via these links
            <a href="https://investorhelpline.nseclearing.in/ClientCollateral/welcomeCLUser" target="blank">
              &nbsp; NCL&nbsp;
            </a>
            |
            <a href="https://www.icclindia.com/DynamicPages/UCCDetails.aspx" target="blank">
              &nbsp;ICCL&nbsp;
            </a>
            |
            <a href="https://clientreports.mcxccl.com/#/" target="blank">
              &nbsp;MCXCCL&nbsp;
            </a>
          </p>

          <p>
            Kindly refer to the
            <a href="https://assets.upstox.com/website/other-advisory-guidelines" target="blank">
              &nbsp; Advisory Guidelines&nbsp;
            </a>
            issued by Exchanges for trading
          </p>

          <div>
            <p>
              <strong>Investment Disclaimer</strong>
            </p>
            <p>
              <strong>Disclaimer</strong>: Investments in the securities market are subject to market risks,
              read all the related documents carefully before investing.
            </p>
          </div>

          <p>
            *Brokerage will not exceed the SEBI prescribed limit and Annual Maintenance charges are free upto
            one year for users onboarded from 14-Feb-2025 onwards
          </p>

          <p>
            <strong>Risk disclosures on:</strong>
            <a href="https://assets.upstox.com/website/risk-disclosures/derivatives.pdf" target="blank">
              &nbsp;Derivatives&nbsp;
            </a>
            |
            <a href="https://assets.upstox.com/website/risk-disclosures/mutual-funds.pdf" target="blank">
              &nbsp;Mutual Funds&nbsp;
            </a>
            |
            <a href="https://assets.upstox.com/website/risk-disclosures/ipo" target="blank">
              &nbsp;IPO&nbsp;
            </a>
            |
            <a
              href="https://assets.upstox.com/website/risk-disclosures/pledge-of-securities.pdf "
              target="blank"
            >
              &nbsp;Pledge of Securities&nbsp;
            </a>
            |
            <a
              href="https://assets.upstox.com/website/risk-disclosures/unauthorized-trading.pdf "
              target="blank"
            >
              &nbsp;Unauthorized Trading&nbsp;
            </a>
            |
            <a
              href="https://assets.upstox.com/website/risk-disclosures/third-party-products.pdf "
              target="blank"
            >
              &nbsp;Third Party Products&nbsp;
            </a>
          </p>

          <p>
            We do not authorize any person or organization to conduct trades on behalf of Upstox customers. If
            you find anyone claiming to be part of Upstox or RKSV or representing Upstox/RKSV and offering
            such services, please send us an email at
            <a href="mailto:complaints@upstox.com">&nbsp;complaints@upstox.com&nbsp;</a>
          </p>

          <div>
            <a href="https://assets.upstox.com/website/valid-upi-handle.pdf " target="blank">
              Use of New Validated UPI Handles in the Securities Market
            </a>
          </div>

          <div>
            <p>
              <strong>Insurance</strong>
            </p>
            <p>
              <strong>RKSV Securities India Pvt. Ltd.</strong> (&quot;Upstox&quot;) with registered office at
              807, New Delhi House Barakhamba Road Connaught Place, New Delhi, Delhi-110001, Delhi (CIN:
              U74900DL2009PTC189166) is a Corporate Agent registered with Insurance Regulatory and Development
              Authority of India (IRDAI) (Category: Composite, IRDAI Regn No.-: CA0918 valid till 05-03-2027).
            </p>
            <p>
              <a
                href="https://assets.upstox.com/website/insurance/disclosures-disclaimers-for-insurance-products.pdf"
                target="blank"
              >
                &nbsp;Disclosures/Disclaimers for Insurance Products
              </a>
            </p>
            <p>
              <strong>Email ID</strong>:
              <a href="mailto:insurancesupport@rksv.in" target="blank">
                &nbsp;insurancesupport@rksv.in&nbsp;
              </a>
            </p>
            <p>
              <strong>Bima Bharosa Portal</strong>:
              <a href="https://bimabharosa.irdai.gov.in/" target="blank">
                &nbsp; https://bimabharosa.irdai.gov.in/
              </a>
            </p>
            <p>
              <strong>IRDAI</strong>:
              <a href="https://irdai.gov.in/" target="blank">
                &nbsp;https://irdai.gov.in/
              </a>
            </p>
            <p>
              <strong>Insurance Ombudsman</strong>:
              <a href="https://www.cioins.co.in/" target="blank">
                &nbsp;https://www.cioins.co.in/
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Algoverse;
